import vars from '../../vars';

// https://docs.sentry.io/clients/javascript/config/
export const sentryConfig = {
  environment: vars.get('TI_ENV'),
  release: RELEASE_VERSION,
  sampleRate: 0.1, // sample 10%
};

export const sentryServerDsn = vars.get('SENTRY_DSN_SERVER');
export const sentryClientDsn = vars.get('SENTRY_DSN_CLIENT');
